import { io } from "socket.io-client";

const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL;

export const socket = io(SOCKET_BASE_URL, {
  // Team Chat owns this socket's lifecycle. This prevents users from
  // remaining online after navigating to another SPA page.
  autoConnect: false,
  reconnection: true,
});
